import * as Types from '../../graphql/generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResolveInvoiceRunErrorMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
  note?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type ResolveInvoiceRunErrorMutation = { __typename?: 'Mutation', resolveInvoiceRunError: { __typename?: 'InvoiceRunError', id: string, resolved_at?: string | null, resolved_by?: string | null, resolution_note?: string | null } };


export const ResolveInvoiceRunErrorDocument = gql`
    mutation ResolveInvoiceRunError($id: UUID!, $note: String) {
  resolveInvoiceRunError(id: $id, note: $note) {
    id
    resolved_at
    resolved_by
    resolution_note
  }
}
    `;
export type ResolveInvoiceRunErrorMutationFn = Apollo.MutationFunction<ResolveInvoiceRunErrorMutation, ResolveInvoiceRunErrorMutationVariables>;

/**
 * __useResolveInvoiceRunErrorMutation__
 *
 * To run a mutation, you first call `useResolveInvoiceRunErrorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveInvoiceRunErrorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveInvoiceRunErrorMutation, { data, loading, error }] = useResolveInvoiceRunErrorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useResolveInvoiceRunErrorMutation(baseOptions?: Apollo.MutationHookOptions<ResolveInvoiceRunErrorMutation, ResolveInvoiceRunErrorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveInvoiceRunErrorMutation, ResolveInvoiceRunErrorMutationVariables>(ResolveInvoiceRunErrorDocument, options);
      }
export type ResolveInvoiceRunErrorMutationHookResult = ReturnType<typeof useResolveInvoiceRunErrorMutation>;
export type ResolveInvoiceRunErrorMutationResult = Apollo.MutationResult<ResolveInvoiceRunErrorMutation>;
export type ResolveInvoiceRunErrorMutationOptions = Apollo.BaseMutationOptions<ResolveInvoiceRunErrorMutation, ResolveInvoiceRunErrorMutationVariables>;